// extracted by css-extract-rspack-plugin
export default {"water":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WaterLayer-WaterLayer-module__water-P58NaG","canvas":"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WaterLayer-WaterLayer-module__canvas-sD1li6"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"water\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WaterLayer-WaterLayer-module__water-P58NaG\",\"canvas\":\"src-shared-components-MainLayout-components-AnimatedWallpaper-LayeredWallpaper-WaterLayer-WaterLayer-module__canvas-sD1li6\"}";
        // 1793875575865
        var cssReload = require("../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  